import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {ActivityDrawer, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {useThemeCustomizer} from '../../app/contexts/ThemeCustomizerContext'
import {TerminalChrome} from '../../app/themes/terminal'
import {GraphiteChrome} from '../../app/themes/graphite'

const MasterLayout = () => {
  const location = useLocation()
  const {activeTheme} = useThemeCustomizer()
  const isTerminal = activeTheme?.slug === 'terminal'
  // graphite family — graphite + variants (e.g. Blossom) via appThemeAttr.
  const isGraphite = activeTheme?.slug === 'graphite' || (activeTheme as any)?.appThemeAttr === 'graphite'

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  // Terminal theme swaps the entire chrome (header + aside) for a bespoke
  // command-line-feel layout. Routes don't know the difference — their
  // content still renders via <Outlet /> exactly as before. PageDataProvider
  // and ScrollTop stay above the switch so page titles and scroll behavior
  // work the same in either theme.
  return (
    <PageDataProvider>
      {isTerminal ? (
        <TerminalChrome>
          <Outlet />
        </TerminalChrome>
      ) : isGraphite ? (
        <GraphiteChrome>
          <Outlet />
        </GraphiteChrome>
      ) : (
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
            <HeaderWrapper />

            <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}

      {/* Global drawers / overlays. Mounted in both chromes so buttons in the
          terminal header can still trigger them (chat drawer, activity drawer,
          etc.) — they're invisible until the matching toggle fires. */}
      <ActivityDrawer />
      {/* DrawerMessenger retired 2026-05 — was the per-customer
          GeminiChatInterface slide-out. Replaced by Andrei sessions:
          header [chat] popover + customer Conversations tab. */}
      <InviteUsers />
      <UpgradePlan />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
